import { omit } from 'es-toolkit';
import React, { Component, ElementType, FormEvent } from 'react';
import { IconButton } from '@mui/material';
import Button, { ButtonProps } from '@mui/material/Button';

interface OwnProps {
  accept: string;
  withIcon: boolean;
  onFileSelected: (files: FileList) => void;
}

type Props = OwnProps & ButtonProps;

class FileUploadButton extends Component<Props> {
  private fileInputRef: React.RefObject<HTMLInputElement | null> = React.createRef();

  onFileSelected = (event: FormEvent<HTMLInputElement>) => {
    const { files } = event.currentTarget;

    if (files != null && files.length > 0) {
      this.props.onFileSelected(files);
    }

    // Reset the input value so that onChange will fire if the same file is uploaded again
    this.fileInputRef.current!.value = '';
  };

  onButtonClick = () => {
    if (this.fileInputRef.current == null) {
      return;
    }

    this.fileInputRef.current!.click();
  };

  render() {
    const ButtonComponent: ElementType = this.props.withIcon ? IconButton : Button;
    const buttonProps = omit(this.props, ['accept', 'onFileSelected', 'withIcon']);

    return (
      <>
        <ButtonComponent {...buttonProps} onClick={this.onButtonClick} />

        <input
          type="file"
          accept={this.props.accept}
          style={{ display: 'none' }}
          onChange={this.onFileSelected}
          onFocus={(event) => {
            event.target.blur();
          }}
          ref={this.fileInputRef}
        />
      </>
    );
  }
}

export default FileUploadButton;
